import React, { useEffect, useState } from 'react';
import TaskItem from './TaskItem';
import '../../../styles/components/management/steps/TaskList.css';

const API_BASE = process.env.REACT_APP_API_BASE;

export default function TaskList({
  unitId,
  stepId,
  reloadTrigger,  // new prop
  onAddTask,
  onEditTask,
  onDeleteTask
}) {
  const [tasks, setTasks] = useState([]);

  const loadTasks = () => {
    fetch(
      `${API_BASE}/app/API/rbmgt/unit_step_task.php` +
      `?unit_id=${unitId}&step_template_id=${stepId}`
    )
      .then(r => r.json())
      .then(data => {
        if (data.success && Array.isArray(data.tasks)) {
          setTasks(data.tasks);
        }
      })
      .catch(console.error);
  };

  // re-fetch when unitId, stepId, or reloadTrigger changes
  useEffect(loadTasks, [unitId, stepId, reloadTrigger]);

  return (
    <div className="task-list">
      <button className="add-task-btn" onClick={onAddTask}>
        + Add Task
      </button>

      {tasks.map(task => (
        <TaskItem
          key={task.TASK_TEMPLATE_ID}
          task={task}
          onEdit={() => onEditTask(task)}
          onDelete={() => onDeleteTask(task.TASK_TEMPLATE_ID)}
        />
      ))}
    </div>
  );
}
